import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from 'react';

export const PartnerFooter = () => {
    return (
        <>
        <section className="bg-gradient-to-b from-grey-light to-white purple gutter">
            <div className="wrapper">
                <div className="w-full md:w-1/2 m-auto md:text-center">
                    <div className="icon mb-4"><img className="w-24 md:m-auto purple" src="https://qh-cs.cdn.prismic.io/qh-cs/f08e748b-fc79-4889-88b9-b76fc9ecfe0f_icon-preferred-partner.svg" /></div>
                    <h2 className="text-purple">Drowning in point solutions</h2>
                    <p className="mb-0">HR leaders have thousands of point solution vendors to choose from. Finding the time to research, implement and manage vendor relationships can be overwhelming and time-consuming.</p>
                </div>
            </div>
        </section>
        {/* <section className="gutter top">
        <div className="wrapper flex flex-col md:flex-row lg:items-center justify-between gap-12 md:gap-24">
            <div className="w-full md:w-1/2 content-side-side">
                <h2>Introducing preferred partners</h2>
                <p>With our flexible Preferred Partners program, we take the hassle out of finding point solutions by following a rigorous vetting and integration process for all digital health solutions. This includes:</p>
                <ul>
                    <li>Simplifying member and HR experience</li>
                    <li>Ensuring each partner delivers proven results for clinical and service quality</li>
                    <li>Streamlining technology integration and security</li>
                    <li>Intervening earlier in member’s health journey to reduce costs and improve health outcomes</li>
                </ul>
                <p>Employers need the targeted member experience that point solutions can deliver, but not the complexity of finding, vetting and implementing potential point solutions. With Preferred Partners, Quantum Health has done the heavy lifting. We’ve built service and data integrations with category leaders. Our proprietary early intercept model and unique member and provider engagement approach help ensure improved utilization, that can lead to better health outcomes.</p>
            </div>
            <div className="relative w-full md:w-1/2 rounded-3xl shadow-xl">
                    <StaticImage src="../../images/partner-footer-1.jpg" className="rounded-3xl" alt="Smiling family coming through the door" />
            </div>
        </div>
        </section> */}
        <section className="gutter top">
        <div className="wrapper flex flex-col md:flex-row lg:items-center justify-between gap-12 md:gap-24">
            
            <div className="w-full md:w-1/2 content-side-side">
                <h2>Taking on the hard stuff — so you can focus on your team</h2>
                <p>From addressing chronic conditions such as behavioral health, diabetes, musculoskeletal (MSK) and gastrointestinal disorders, to optimizing prescription drug utilization and price transparency, Quantum Health’s Preferred Partners are here to deliver the results you — and your members — need. These valuable partnerships revealed <strong>an increase in enrollment, decrease in registration abandonment and ongoing utilization</strong> across many organizations.</p>
            </div>
            <div className="relative w-full md:w-1/2 rounded-3xl shadow-xl">
                    <StaticImage src="../../images/partner-footer-2.jpg" className="rounded-3xl" alt="Smiling family coming through the door" />
            </div>
            
        </div>
        <div className="gutter bot flex justify-center items-center">
            <Link to="/comprehensive-care-solutions/" className="btn bg-purple text-lg pr-8 pl-5">View more partners</Link>
        </div>
        </section>
        </>
    );
    
}

